import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonContent,
  IonButton,
  IonText,
  IonInput,
  IonItem,
  IonList,
  IonSelect,
  IonSelectOption,
} from '@ionic/react';
import { useClaimHub } from '../../application/use-cases/hubs/useClaimHub';

const ClaimHub: React.FC = () => {
  const { hubId, setHubId, code, setCode, fromQr, siteId, setSiteId, sites, claiming, error, result, claim, goToStations } =
    useClaimHub();

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/app/devices" />
          </IonButtons>
          <IonTitle>Vincular hub</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className="ion-padding">
        {result ? (
          <>
            <IonText>
              <h2>Listo, el hub es tuyo</h2>
              <p style={{ fontSize: 14, lineHeight: 1.6 }}>
                <strong>{result.hub.id}</strong> quedó vinculado a tu cuenta
                {result.hub.status === 'online' ? ' y está en línea.' : '. Todavía no se conectó: enchufalo y cargale el WiFi.'}
              </p>
              <p style={{ fontSize: 14, lineHeight: 1.6 }}>
                {result.createdStations.length > 0
                  ? `Se agregaron ${result.createdStations.length} estaciones. Ponéles nombre y ubicalas en su lote.`
                  : 'Las estaciones del hub van a aparecer solas apenas se conecten.'}
              </p>
            </IonText>
            <IonButton expand="block" onClick={goToStations}>
              Ver mis estaciones
            </IonButton>
          </>
        ) : (
          <>
            <IonText color="medium">
              <p style={{ fontSize: 14, lineHeight: 1.6 }}>
                {fromQr
                  ? 'Confirmá para sumar este hub a tu cuenta. Sus estaciones aparecen solas.'
                  : 'Escribí el id y el código que están en la etiqueta del hub (o escaneá el QR "Vincular").'}
              </p>
            </IonText>

            <IonList inset>
              <IonItem>
                <IonInput
                  label="Hub"
                  labelPlacement="stacked"
                  placeholder="hub-a73f38"
                  value={hubId}
                  readonly={fromQr}
                  onIonInput={(e) => setHubId(e.detail.value ?? '')}
                />
              </IonItem>
              <IonItem>
                <IonInput
                  label="Código"
                  labelPlacement="stacked"
                  placeholder="XXXX-XXXX"
                  value={code}
                  readonly={fromQr}
                  autocapitalize="characters"
                  onIonInput={(e) => setCode(e.detail.value ?? '')}
                />
              </IonItem>
              {sites.length > 0 && (
                <IonItem>
                  <IonSelect
                    label="Campo donde se instala"
                    labelPlacement="stacked"
                    placeholder="Elegir después"
                    value={siteId}
                    onIonChange={(e) => setSiteId(e.detail.value ?? null)}
                  >
                    <IonSelectOption value={null}>Elegir después</IonSelectOption>
                    {sites.map((s) => (
                      <IonSelectOption key={s.id} value={s.id}>
                        {s.name}
                      </IonSelectOption>
                    ))}
                  </IonSelect>
                </IonItem>
              )}
            </IonList>

            {error && (
              <IonText color="danger">
                <p style={{ fontSize: 13 }}>{error}</p>
              </IonText>
            )}

            <IonButton expand="block" style={{ marginTop: 16 }} onClick={claim} disabled={claiming}>
              {claiming ? 'Vinculando...' : 'Vincular a mi cuenta'}
            </IonButton>
          </>
        )}
      </IonContent>
    </IonPage>
  );
};

export default ClaimHub;
